export default __webpack_public_path__ + "static/media/NobelWGL-Book.f456c697.eot";